import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  current: {},
  latest: {},
  stats: {},
  calculations: [],
  calculationsPagination: {
    total: 0,
    page: 1,
    limit: 20,
    pages: 0,
  },
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    pages: 0,
  },
};

const batchesSlice = createSlice({
  name: "batches",
  initialState,
  reducers: {
    setBatchesList: (state, { payload }) => ({
      ...state,
      list: [...payload.batches],
      pagination: payload.pagination || state.pagination,
    }),
    setCurrentBatch: (state, { payload }) => ({
      ...state,
      current: { ...payload.batch },
    }),
    setLatestBatch: (state, { payload }) => ({
      ...state,
      latest: { ...payload.batch },
    }),
    setBatchesStats: (state, { payload }) => ({
      ...state,
      stats: { ...payload.summary },
    }),
    setBatchCalculations: (state, { payload }) => ({
      ...state,
      calculations: [...payload.calculations],
      calculationsPagination: payload.pagination || state.calculationsPagination,
    }),
    resetBatchesState: () => ({
      list: [],
      current: {},
      latest: {},
      stats: {},
      calculations: [],
      calculationsPagination: {
        total: 0,
        page: 1,
        limit: 20,
        pages: 0,
      },
      pagination: {
        total: 0,
        page: 1,
        limit: 20,
        pages: 0,
      },
    }),
  },
});

export const {
  setBatchesList,
  setCurrentBatch,
  setLatestBatch,
  setBatchesStats,
  setBatchCalculations,
  resetBatchesState,
} = batchesSlice.actions;

export default batchesSlice.reducer;
